import * as types from './mutation-types'
/* eslint-disable */

export const loadPlannings = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/' + data.id + '/programs/collection', {params: data}).then((response) => {
            commit(types.LOAD_PLANNINGS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadProgramEnum = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/program/enum').then((response) => {
            commit(types.LOAD_PROGRAM_ENUMS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAtelierTypeEnum = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/atelier/type/enum').then((response) => {
            commit(types.LOAD_ATELIER_TYPE_ENUMS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createPlanning = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/event/' + data.event_id + '/program', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updatePlanning = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('update/event/' + data.event_id + '/program/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getEventPlanning = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/' + data.event_id + '/event/program/' + data.id).then((response) => {
            commit(types.SET_CURRENT_PLANNING, response.data.event_program)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deletePlanning = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/event/' + data.event_id + '/program/' + data.id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadModerators = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/participators/' + id + '/moderator').then((response) => {
            commit(types.LOAD_MODERATORS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadPresentators = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/participators/' + id + '/presentator').then((response) => {
            commit(types.LOAD_PRESENTATORS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAtelierPrograms = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/atelier/' + id + '/programs/collection', {params: {atelier_id: id}}).then((response) => {
            commit(types.LOAD_ATELIER_PROGRAMS, response.data?.programs)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createProgram = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/atelier/'+data.atelier_id+'/program', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProgram = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/atelier/' + data.atelier_id + '/program/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProgram = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('delete/atelier/'+data.atelier_id+'/program/' + data.id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addGuestsToAtelier = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('add/guests/to/private/' + data.atelier_id + '/atelier', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendInvitationGuestByMail = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('send/invitation/guest/' + data.guest_id + '/to/private/' + data.atelier_id + '/atelier' , data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendInvitationGuestByTwilio = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('events/send/invitation/whatsapp' , data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeGuestsToAtelier = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('remove/guests/to/private/' + data.atelier_id + '/atelier', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
